import { useState, useEffect, useRef } from "react";
import { ReactjsIcon, JavascriptIcon, CssIcon, ExpoIcon, ExpressIcon, FigmaIcon, GitIcon, GitLabIcon, GithubIcon, HtmlIcon, NodejsIcon, JestIcon, MaterialIcon, MongoIcon, MysqlIcon, PhpIcon, PostmanIcon, TailwindIcon, } from "../assets/icons";

const skillsData = [
    {
        title: "Front-End",
        items: [
            { name: "React", Icon: ReactjsIcon },
            { name: "HTML", Icon: HtmlIcon },
            { name: "CSS", Icon: CssIcon },
            { name: "Material", Icon: MaterialIcon },
            { name: "Tailwind", Icon: TailwindIcon },
            { name: "Javascript", Icon: JavascriptIcon },
        ]
    },
    {
        title: "Backend",
        items: [
            { name: "NodeJS", Icon: NodejsIcon },
            { name: "Express", Icon: ExpressIcon },
            { name: "PHP", Icon: PhpIcon },
            { name: "MySQL", Icon: MysqlIcon },
            { name: "Mongo", Icon: MongoIcon },
            // { name: "SQL", Icon: SqlIcon },
        ]
    },
    {
        title: "Mobile",
        items: [
            { name: "Expo", Icon: ExpoIcon },
            { name: "React", Icon: ReactjsIcon },
        ]
    },
    {
        title: "Herramientas",
        items: [
            { name: "Jest", Icon: JestIcon },
            { name: "Figma", Icon: FigmaIcon },
            { name: "Postman", Icon: PostmanIcon },
            { name: "Git", Icon: GitIcon },
            { name: "Gitlab", Icon: GitLabIcon },
            { name: "Github", Icon: GithubIcon },
        ]
    }
];

const Skills = () => {
    const [isVisible, setIsVisible] = useState(false);
    const skillsRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Se desconecta para animar solo la primera vez que se hace scroll
                }
            },
            { threshold: 0.1 } // Se dispara cuando el 10% del componente es visible en pantalla
        );

        if (skillsRef.current) {
            observer.observe(skillsRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div className="ps-5 pt-0 pe-5 pb-0 m-0 skills-component" id="skills" ref={skillsRef}>
                <h3 className="text-uppercase title text-center title">Tecnologias</h3>
                <div className="row g-4 justify-content-center text-center">
                    {skillsData.map((category, index) => (
                        <div key={index} className="col-12 col-md-6">
                            <div className={`h-100 p-4 rounded text-center gap-3 d-flex flex-column align-items-center text-uppercase ${isVisible ? 'fade-in' : ''}`} style={{ backgroundColor: "#d8d8d8ff", animationDelay: `${index * 0.2}s`, visibility: isVisible ? 'visible' : 'hidden' }}>
                                <h4 className="subtitle text-dark mb-3 fw-bold">{category.title}</h4>
                                {category.items.map((item, idx) => {
                                    const IconComponent = item.Icon;
                                    return (
                                        <div key={idx} className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-3 w-100 py-2">
                                            <IconComponent width={50} height={50} />
                                            <h6 className="m-0 fs-6 fw-bold text-dark">{item.name}</h6>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default Skills;
